"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Container = _styledComponents.default.button`
  align-items: center;
  background-color: ${p => p.theme.colors.deepSkyBlue};
  border-color: ${p => p.theme.colors.deepSkyBlue};
  border-radius: ${(0, _polished.rem)(4)};
  border-style: solid;
  border-width: ${(0, _polished.rem)(2)};
  color: white;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: ${(0, _polished.rem)(12)};
  line-height: 1;
  outline: 0;
  padding: ${(0, _polished.rem)(4)};
  white-space: nowrap;

  &:active {
    transform: translateY(${(0, _polished.rem)(1)});
  }
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * A basic button component that should render nicely on any platform. It responds to a callback when pressed and
 * supports a minimal level of customization.
 *
 * @beta
 */
function Button({
  behavior,
  children,
  disabled,
  onPress,
  testID
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-testid": testID,
    disabled: disabled,
    onClick: onPress,
    type: behavior
  }, children);
}